import {makeSignUpValidateToken} from 'main/factories/usecases';
import {SignUpValidateTokenParams} from './types.js';

export async function signUpValidateToken({signal, ...tokenParams}: SignUpValidateTokenParams) {
	const response = await makeSignUpValidateToken().get({signal, ...tokenParams});

	return response;
}
